import styled from 'styled-components';

export const ModuleLoadingFallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`;

export const ModuleLoadingFallbackTitle = styled.h1`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.8px;
  color: ${(props) => props.theme.colors.darkBlue};
`;

export const ModuleLoadingFallbackPargraph = styled.p`
  color: ${(props) => props.theme.colors.darkBlue};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin-bottom: 20px;
`;

export const ModuleLoadingFallbackButtonGroup = styled.div`
  display: flex;
  margin-bottom: 20px;

  & > * + * {
    margin-left: 8px;
  }
`;
